import { rbAddReferencePrefix } from 'lib/riskbase';
import React from 'react';
import { Icon, ICONS } from './Icon';
import { Txt } from './Txt';
import { Platform } from 'react-native';

type Props = {
  reference?: string;
  customReference: string | null;
  organisation?: string | null;
};

export const ReferenceToText: React.FC<Props> = ({
  reference,
  customReference,
  organisation,
}) => {
  return (
    <Txt size="xsmall" numberOfLines={1}>
      {reference && <Txt size="xsmall">{rbAddReferencePrefix(reference)}</Txt>}
      {!!customReference && (
        <>
          {'\u00A0\u00A0'}
          <Icon
            source={ICONS.HashtagLight}
            size={16}
            style={{
              transform: [
                Platform.OS === 'web' ? { translateY: 3 } : { translateY: 6 },
              ],
              marginTop: -3,
            }}
          />
          {'\u00A0'}
          {customReference}
        </>
      )}
      {!!organisation && (
        <>
          {'\u00A0\u00A0'}
          <Icon
            source={ICONS.HouseBuildingLight}
            size={16}
            style={{
              transform: [
                Platform.OS === 'web' ? { translateY: 3 } : { translateY: 6 },
              ],
              marginTop: -3,
            }}
          />
          {'\u00A0'}
          {organisation}
        </>
      )}
    </Txt>
  );
};
